// removed by extract-text-webpack-plugin
module.exports = {"slick-prev":"src-components-Carousel----Carousel-module---slick-prev---3fUtj","slick-next":"src-components-Carousel----Carousel-module---slick-next---1WQW7","quote":"src-components-Carousel----Carousel-module---quote---1AqXe"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Carousel/Carousel.module.scss
// module id = 277
// module chunks = 74537795826934 162898551421021